import { supabase } from './supabase';
import type { TenantCommissionRaw } from './commissions';
import { extractFnError } from './odooInvoices';

/**
 * Chargement des commissions réseau (RPC `network_commissions`, super_admin).
 * Résilient : renvoie ok/erreur, ne jette jamais.
 */
export interface LoadCommissionsResult {
  ok: boolean;
  tenants: TenantCommissionRaw[];
  error?: string;
}

export async function loadCommissions(days = 30): Promise<LoadCommissionsResult> {
  const { data, error } = await supabase.rpc('network_commissions', { p_days: days });
  if (error) return { ok: false, tenants: [], error: error.message };
  const raw = (data ?? {}) as { tenants?: unknown };
  const list = Array.isArray(raw.tenants) ? (raw.tenants as TenantCommissionRaw[]) : [];
  return { ok: true, tenants: list };
}

export interface CreateInvoiceResult { ok: boolean; message: string }

/** Génère (brouillon Odoo) la facture mensuelle d'un resto : commission à recouvrer + options. */
export async function createMonthlyInvoice(slug: string, year: number, month: number): Promise<CreateInvoiceResult> {
  const { data, error } = await supabase.functions.invoke('odoo-create-invoice', {
    body: { tenant_slug: slug, year, month },
  });
  if (error) return { ok: false, message: await extractFnError(error, 'Génération impossible.') };
  const res = (data ?? {}) as {
    ok?: boolean; duplicate?: boolean; skipped?: boolean; reason?: string; error?: string;
    invoice_id?: number; recouvrer_orders?: number;
  };
  if (!res.ok) return { ok: false, message: res.error ?? 'Échec.' };
  if (res.duplicate) return { ok: true, message: `Déjà facturé (brouillon #${res.invoice_id}).` };
  if (res.skipped) return { ok: true, message: res.reason ?? 'Rien à facturer ce mois.' };
  return { ok: true, message: `✅ Brouillon créé (#${res.invoice_id}) — ${res.recouvrer_orders ?? 0} cmd à recouvrer.` };
}
